import React from 'react'
import styled from 'styled-components'
import novoLogoWhite from 'images/novologowhite.png'

const Footer = () => (
  <FooterWrapper>
    <StyledFooter>
      <img
        src={novoLogoWhite}
        style={{ height: '30px', paddingLeft: '16px' }}
        alt="logo"
      />
      <FooterText>
        <p>5944 Luther Ln. Ste 925, Dallas, TX 75225</p>
        <p>info@novolabs.com</p>
        <p>214.673.9999</p>
      </FooterText>
    </StyledFooter>
  </FooterWrapper>
)

const FooterWrapper = styled.div`
  background-color: var(--novo-dark-gray);
  display: flex;
  align-items: center;
  height: 56px;
`
const StyledFooter = styled.footer`
  align-items: center;
  display: flex;
  font-size: 10px;
  justify-content: space-between;
  margin: auto;
  max-width: 1200px;
  width: 100%;

  p {
    margin: 0;
  }
`

const FooterText = styled.div`
  color: white;
  padding-right: 16px;
  text-align: right;
`

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js